import { render, staticRenderFns } from "./report_add.vue?vue&type=template&id=2dc613e2&scoped=true&"
import script from "./report_add.vue?vue&type=script&lang=js&"
export * from "./report_add.vue?vue&type=script&lang=js&"
import style0 from "./report_add.vue?vue&type=style&index=0&id=2dc613e2&lang=less&scoped=true&"
import style1 from "./report_add.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc613e2",
  null
  
)

export default component.exports